const STORAGE_KEY = 'viewAgent';

let cachedDefaultViewPeriod: any;

export const viewAgent = {
  get(): any {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data === null) {
      return data;
    }
    return JSON.parse(data);
  },
  set(dateRange: any): void {
    const data = JSON.stringify(dateRange);
    localStorage.setItem(STORAGE_KEY, data);
  },
  getDefault(): any {
    if (!cachedDefaultViewPeriod) {
      cachedDefaultViewPeriod = null;
    }
    return cachedDefaultViewPeriod;
  },
};
